<template>
  <popup
    max-width="88%"
    :overlay="loading"
    overlay-class="feiyu-toast--overlay"
    position="center"
    :visible="visible"
    @update:visible="onVisibleChange"
  >
    <div :class="['feiyu-toast', { 'feiyu-toast--loading': loading }]">
      <div class="feiyu-toast--content">
        <slot v-if="$slots.default" />
        <span v-else-if="loading" class="feiyu-toast--spinner" />
        <span v-else>{{ message }}</span>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from "./popup.vue";

export default {
  components: { Popup },
  emits: ["update:visible"],
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    message: { type: String, default: "" },
  },
  methods: {
    onVisibleChange(value) {
      this.$emit("update:visible", value);
    },
  },
};
</script>

<style lang="less">
.feiyu-toast {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  border-radius: 15px;
  background: rgba(51, 51, 51, 0.7);
  color: #ffffff;
  line-height: 1;
}

.feiyu-toast--overlay {
  background: transparent;
}

.feiyu-toast--loading {
  padding: 16px 20px;
}

.feiyu-toast--content {
  font-size: 12px;
}

.feiyu-toast--spinner {
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.28);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: feiyu-toast-rotate 0.8s linear infinite;
}

@keyframes feiyu-toast-rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
